import React from "react";

export const IconTemplates = () => {
    return (
        <svg
            width="40"
            height="41"
            viewBox="0 0 40 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M33.75 6.58334H6.25C5.58696 6.58334 4.95107 6.84674 4.48223 7.31558C4.01339 7.78442 3.75 8.4203 3.75 9.08334V31.5833C3.75 32.2464 4.01339 32.8823 4.48223 33.3511C4.95107 33.82 5.58696 34.0833 6.25 34.0833H33.75C34.413 34.0833 35.0489 33.82 35.5178 33.3511C35.9866 32.8823 36.25 32.2464 36.25 31.5833V9.08334C36.25 8.4203 35.9866 7.78442 35.5178 7.31558C35.0489 6.84674 34.413 6.58334 33.75 6.58334ZM33.75 9.08334V15.3333H6.25V9.08334H33.75ZM6.25 17.8333H15V31.5833H6.25V17.8333ZM33.75 31.5833H17.5V17.8333H33.75V31.5833Z"
                fill="#08212D"
            />
        </svg>
    );
};
